<template>
  <f7-popup ref="popup" :opened="opened" @popup:closed="$emit('closed')"
            class="receipt-viewer photo-browser-standalone">
    <f7-page class="photo-browser-page photo-browser-page-dark page-with-subnavbar"
             :class="{'photo-browser-exposed' : exposed}">
      <f7-navbar>
        <f7-nav-left>
          <f7-link popup-close=".receipt-viewer">
            <f7-icon icon="icon-back" color="white"></f7-icon>
            <span>{{$t('action.close')}}</span>
          </f7-link>
        </f7-nav-left>
        <f7-nav-title v-if="total > 1">{{title}}</f7-nav-title>
        <f7-subnavbar v-if="currentReceipt">
          {{caption}}
        </f7-subnavbar>
      </f7-navbar>
      <f7-swiper class="photo-browser-swiper-container" :params="params">
        <f7-swiper-slide v-for="(receipt, i) in receipts" class="photo-browser-slide" :key="i">
          <div class="swiper-zoom-container">
            <img v-if="isImage(receipt) || (isPDF(receipt) && isIOS)" class="receipt-img swiper-lazy"
                 :data-src="url(receipt)">
            <iframe v-else-if="isPDF(receipt)" class="receipt-file" :src="url(receipt)"></iframe>
            <span v-show="!isLoading" class="no-preview-receipt">📎📄<br>{{$t('title.noPreview')}}</span>
          </div>
        </f7-swiper-slide>
      </f7-swiper>
      <div v-show="isLoading" class="preloader swiper-lazy-preloader color-white"></div>
      <div v-show="!exposed">
        <f7-fab position="left-bottom" slot="fixed" :text="$t('action.delete')" color="pink" @click="delBtn">
          <f7-icon ios="f7:delete" md="material:remove"></f7-icon>
        </f7-fab>
        <f7-fab v-if="showAdd" position="right-bottom" slot="fixed" :text="$t('action.attach')" @click="selBtn">
          <f7-icon ios="f7:plus" md="material:add"></f7-icon>
        </f7-fab>
        <f7-fab v-if="!isImage(currentReceipt)" position="center" slot="fixed" :text="openText" @click="openFile">
          <f7-icon ios="f7:arrow_up" md="material:arrow_upward"></f7-icon>
        </f7-fab>
      </div>
      <f7-toolbar tabbar bottom-md v-show="total > 1">
        <f7-link class="photo-browser-prev">
          <f7-icon icon="icon-back"></f7-icon>
        </f7-link>
        <f7-link class="photo-browser-next">
          <f7-icon icon="icon-forward"></f7-icon>
        </f7-link>
      </f7-toolbar>
    </f7-page>
  </f7-popup>
</template>

<script>
  import cordovaHelpers from '@/utils/cordova-helpers'
  import helpers from '@/utils/helpers'

  export default {
    name: 'receipt-viewer',
    computed: {
      caption () {
        return this.currentReceipt.name ? this.currentReceipt.name : this.$t('title.uploadedOn', {date: this.toDate(this.currentReceipt.created)})
      },
      currentReceipt () {
        return this.receipts[this.index]
      },
      openText () {
        return this.currentReceipt ? this.$t('action.openFile', {file: this.currentReceipt.fileExtension.substring(1)}) : this.$t('action.open')
      },
      swiper () {
        return this.$f7.swiper.get()
      },
      title () {
        return this.$t('title.currentOfTotal', {current: this.index + 1, total: this.total})
      },
      total () {
        return this.receipts.length
      }
    },
    data () {
      return {
        index: 0,
        isLoading: false,
        exposed: false,
        params: {
          lazy: true,
          preloadImages: false,
          navigation: {
            nextEl: '.photo-browser-next',
            prevEl: '.photo-browser-prev',
          },
          spaceBetween: 20,
          zoom: true,
          on: {
            click: this.expose,
            lazyImageLoad: this.imageLoad,
            lazyImageReady: this.imageReady,
            slideChange: this.slideChange
          }
        }
      }
    },
    methods: {
      close () {
        this.$emit('closed')
        this.$refs.popup.close()
      },
      delBtn () {
        this.$emit('delete-receipt', this.currentReceipt.id)
      },
      expose () {
        this.exposed = !this.exposed
      },
      imageLoad () {
        this.isLoading = true
      },
      imageReady () {
        this.isLoading = false
      },
      isImage (receipt) {
        return receipt ? receipt.contentType.startsWith('image') : false
      },
      isPDF (receipt) {
        return receipt ? receipt.contentType === 'application/pdf' : false
      },
      openFile () {
        const receiptUrl = this.url(this.currentReceipt)
        const url = this.isAndroid ? `http://docs.google.com/viewer?url=${receiptUrl}` : receiptUrl
        window.open(url, this.hrefTarget)
      },
      selBtn () {
        this.$emit('attach-receipt', this.currentReceipt.id)
        this.close()
      },
      slideChange () {
        this.index = this.swiper.realIndex
      },
      url (receipt) {
        return `${process.env.VUE_APP_AIO_API}${receipt.imgUrl}${localStorage.levima_api_key}`
      }
    },
    mixins: [cordovaHelpers, helpers],
    props: {
      opened: Boolean,
      receipts: Array,
      showAdd: {
        type: Boolean,
        default: true
      }
    },
    updated () {
      this.swiper.$el.find('img[data-src]').forEach(img => img.classList.remove('swiper-lazy-loaded'))
      this.swiper.lazy.load()
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .md .photo-browser-page-dark .navbar {
    background: linear-gradient(to right, $toolbar-charcoal1, $toolbar-charcoal2) !important;
  }

  .ios .subnavbar::after {
    display: none;
  }

  .subnavbar {
    font-size: 14px;
    .ios &, .md & {
      height: 24px;
    }
  }

  .subnavbar /deep/ .subnavbar-inner {
    justify-content: flex-end;
  }

  iframe {
    border: none;
  }

  .no-preview-receipt {
    color: $white;
    position: absolute;
    font-size: 24px;
    z-index: -1;
  }

  .receipt-img {
    background: $white;
  }

  .receipt-file {
    pointer-events: none;
  }
</style>
